import creditEngineRepository, {CreditEngineRepository} from "@/repositories/creditengine/CreditEngineRepository";
import {environment} from "@/environments/environment";

const resource = "/appuser";
export default {
  authenticate(appuser) {
    creditEngineRepository.setContentType("application/json");
    return CreditEngineRepository.post(`${resource}`, appuser);
  }
}

CreditEngineRepository.interceptors.request.use(
    config => {
      config.headers["Content-Type"] = "application/json";
      config.headers["Fineract-Platform-TenantId"] = environment.fineractPlatformTenantId;
      config.headers["x-ezcred-secret-key"] = environment.ezCredSecretKey;
      config.headers["x-request-time"] = (new Date).getTime();
      // Do something before request is sent
      return config;
    },
    error => {
      // Do something with request error
      return Promise.reject(error);
    }
);